import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import {
  StyledAccordionItem,
  StyledContent,
  StyledDetails,
  StyledSummary,
  StyledTitle,
  StyledTrigger,
  StyledTriggerIcon
} from './Accordion.styled';
import { AccordionItemProps } from './Accordion.types';

const AccordionItem: React.FC<AccordionItemProps> = ({
  summary,
  details,
  active
}) => {
  const [isActive, setIsActive] = useState(active);

  function toggleAccordion(): void {
    setIsActive((prev) => !prev);
  }

  useEffect(() => {
    if (active) {
      setIsActive(active);
    }
  }, [active]);

  return (
    <StyledAccordionItem>
      <StyledSummary>
        <StyledTrigger
          className={classnames({
            'is-active': isActive
          })}
          onClick={toggleAccordion}
          type="button"
        >
          <StyledTitle>{summary}</StyledTitle>
          <StyledTriggerIcon>
            <FontAwesomeIcon icon={faCaretDown} />
          </StyledTriggerIcon>
        </StyledTrigger>
      </StyledSummary>

      <StyledDetails style={{ maxHeight: `${isActive ? '1500px' : '0px'}` }}>
        <StyledContent>{details}</StyledContent>
      </StyledDetails>
    </StyledAccordionItem>
  );
};

export default AccordionItem;
